import { Button } from "../ui";

export const Guests = () => {
  return (
    <section className="w-full pb-5 sm:pb-28">
      <div className="flex flex-col items-center justify-between gap-3 sm:gap-5">
        <h2
          className="text-center text-[1.575rem] font-bold tracking-wider sm:text-lg uppercase"
          style={{ fontFamily: "ofont_flow" }}
        >
          Дорогие гости!
        </h2>

        <div className="flex flex-col items-center justify-between gap-3 sm:gap-5 max-w-3xl px-11 text-center">
          <p
            className="text-[15px] leading-[1.75] font-bold tracking-[-0.25px]"
            style={{ fontFamily: "ofont_flow" }}
          >
            Подтвердите свое присутствие
            <br />
            на нашем празднике до 21 мая.
          </p>

          <Button
            className="w-3/4 px-4 py-2 bg-[var(--color-olive-gold)] rounded-full"
            href="https://t.me/+fOVNkRCFqZM1YTNi"
            target="_blank"
          >
            <span
              className="text-white text-center text-sm font-bold tracking-wider"
              style={{ fontFamily: "ofont_flow" }}
            >
              Чат
            </span>
          </Button>

          <p className="px-4 text-xs text-wrap wrap-break-word leading-relaxed font-bold text-[var(--primary)]">
            Присоединяйтесь к нашему телеграм-каналу с новостями! <br /> Там вы
            сможете поделиться своими эмоциями, фото и видео.
          </p>
        </div>
      </div>
    </section>
  );
};
